import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    selector: 'installation-date',
    templateUrl: './installation-date.component.html',
    standalone: false
})
export class InstallationDatePluginComponent {
  public dates: any[];
  public config: any;
  public editRoute = ['installation', 'date', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.dates = this.config.Dates;
  }
}
PluginComponent.plugins['installationdate'] = InstallationDatePluginComponent;
